// cs2586 (06/10/2026): o cliente pediu o menu lateral (celular) sem os atalhos fixos
// "Anuncie seu imóvel", "Não encontrou seu imóvel?" e "Fale Conosco". Fora da lista, NADA muda.
export const DRAWER_SEM_ATALHOS = new Set<number>([2586]);

export const drawerSemAtalhos = (site: any): boolean => DRAWER_SEM_ATALHOS.has(Number(site?.id));
